const DEFAULT_PARTNER = "ba";
const DEFAULT_LOCALE = "en-GB";
const PARTNER_COOKIE = "AVIOS_OPCO";
const LOCALE_COOKIE = "AVIOS_OPCO_LANG";

type CookiesContext = {
  partner: string;
  locale: string;
};

const getCookieByName = (cookieName: string): string | undefined => {
  if (typeof document === "undefined" || !document.cookie) {
    return undefined;
  }

  const cookiePrefix = `${cookieName}=`;
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    cookie = cookie.trim();

    if (cookie.startsWith(cookiePrefix)) {
      return decodeURIComponent(cookie.slice(cookiePrefix.length));
    }
  }

  return undefined;
};

export const useCookies = (): CookiesContext => {
  const partner = (getCookieByName(PARTNER_COOKIE) ?? DEFAULT_PARTNER).toLowerCase();
  const locale = getCookieByName(LOCALE_COOKIE) ?? DEFAULT_LOCALE;

  return { partner, locale };
};
